// extracted by mini-css-extract-plugin
module.exports = {"sponsorsTierOne":"aJzPY","section":"E7UWc","content":"U74E0","sponsorsTitle":"_3RT4G","footerText":"_33jNC","copyright":"_3DthN"};